/**
 * Les FORMES PARALLÈLES de la compréhension de l'écrit (11/10/2026). En compréhension, une question n'a de
 * sens qu'avec son texte : remesurer sur le texte de septembre, c'est mesurer la mémoire. Le QCM de suivi
 * propose donc un autre texte, du même support, aux mêmes compétences, et la progression se compare par
 * compétence et par support. Le lexique, les compétences langagières de 5e et les maths gardent leurs
 * variantes, comparées question par question.
 *
 * Les questions d'une forme sont créées en base par un script du back d'après ces modules (communes à tous
 * les collèges, jamais nationales) ; leur texte reste ici, référencé par support_lecture.
 */
import { FORME_6E } from './positionnement6e';
import { FORME_4E } from './forme4e';
import { COMPETENCES } from './competences';

// 6e : l'outil de positionnement du ministère ; 4e : nos deux textes, sans seuils étalonnés
export const FORMES_PARALLELES = [FORME_6E, FORME_4E];

/** La forme parallèle d'un niveau ('6'…), ou null. */
export const formeDuNiveau = (niveau) => FORMES_PARALLELES.find((f) => f.niveau === String(niveau)) || null;

const PAR_LIBELLE = new Map(Object.entries(COMPETENCES).map(([cle, libelle]) => [libelle, cle]));

/** La compétence d'une question de compréhension de 6e (septembre ou forme parallèle), lue dans son libellé. */
export const competenceDuLibelle = (nomLabel) => PAR_LIBELLE.get(String(nomLabel || '').trim()) || null;

// Le support de chaque texte : ceux de septembre, puis ceux des formes parallèles
const SUPPORT_DU_TEXTE = new Map([
    ["Compréhension de l'écrit Arachné", 'litteraire'],
    ["Compréhension de l'écrit Document Sommeil", 'documentaire'],
    ["Compréhension de l'écrit Petit Chose", 'litteraire'],
    ["Compréhension de l'écrit Volcans sous la glace", 'documentaire'],
    ...FORMES_PARALLELES.flatMap((f) => f.textes.map((t) => [t.typeLabel, t.support])),
]);

/** Le support d'un texte de compréhension (son type_label) : 'litteraire', 'documentaire', ou null. */
export const supportDuTexte = (typeLabel) => SUPPORT_DU_TEXTE.get(String(typeLabel || '').replace(/’/g, "'")) || null;
